import { logger } from '../../../utils/logger';
import { getVoiceService } from '../call-control';

/**
 * Blind transfer to skill/queue
 * Transfers the call directly to a skill queue without consultation
 */
export async function blindTransferToSkill(_contactId: string, skillId: string): Promise<void> {
  logger.debug('[CXone SDK] Blind transfer to skill:', skillId);
  const service = getVoiceService();
  await service.dialSkill(parseInt(skillId, 10));
  await service.transferContact();
}

/**
 * Blind transfer to agent
 * Transfers the call directly to another agent without consultation
 */
export async function blindTransferToAgent(_contactId: string, agentId: string): Promise<void> {
  logger.debug('[CXone SDK] Blind transfer to agent:', agentId);
  const service = getVoiceService();
  await service.dialAgent(agentId, '');
  await service.transferContact();
}

/**
 * Blind transfer to external phone number
 * Transfers the call directly to an external number without consultation
 */
export async function blindTransferToPhone(
  _contactId: string,
  phoneNumber: string,
  skillId?: string
): Promise<void> {
  logger.debug('[CXone SDK] Blind transfer to phone:', phoneNumber);
  const service = getVoiceService();
  await service.dialPhone({
    phoneNumber,
    skillId: skillId ? parseInt(skillId, 10) : 0,
  });
  await service.transferContact();
}

/**
 * Warm transfer (consult first)
 * Initiates a consultation call before transferring
 */
export async function warmTransfer(
  _contactId: string,
  target: { skillId?: string; agentId?: string; phoneNumber?: string }
): Promise<void> {
  logger.debug('[CXone SDK] Warm transfer (consult):', target);
  const service = getVoiceService();
  if (target.agentId) {
    await service.consultAgent(parseInt(target.agentId, 10));
  } else if (target.skillId) {
    await service.dialSkill(parseInt(target.skillId, 10));
  } else if (target.phoneNumber) {
    await service.dialPhone({
      phoneNumber: target.phoneNumber,
      skillId: 0,
    });
  }
}

/**
 * Complete warm transfer
 * After consultation, transfer the original caller to the consult party
 */
export async function completeWarmTransfer(_contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Completing warm transfer');
  const service = getVoiceService();
  await service.transferContact();
}
